import { atom as stateSegment } from 'jotai';

interface ImageGenerationModal {
  isImageGenerationModalOpen: boolean;
}

export const ImageGenerationModalAtom = stateSegment<ImageGenerationModal>({
  isImageGenerationModalOpen: false,
});

ImageGenerationModalAtom.debugLabel = 'ImageGenerationModalAtom';
